import { getDDMMYYYYFromYYYYMMDD, getNumberFormat } from "../../utils/enums";


export const PaymentPlanColumns = () => {
    return [
        { field: "id", headerName: "ID", width: 90, hide: true },
        {
          field: "installmentDate",
          headerName: "Taksit Tarihi",
          sortable: false,
          align: "center",
          flex: 1,
          minWidth: 130,
          valueGetter: (params) => {
            return getDDMMYYYYFromYYYYMMDD(params.value);
          },
        },
        {
          field: "installmentAmount",
          headerName: "Taksit Tutarı",
          sortable: false,
          type: "number",
          align: "right",
          flex: 1,
          minWidth: 140,
          headerAlign: "center",
          valueGetter: (params) => {
            return getNumberFormat(params.value);
          },
        },
        {
          field: "installmentPrincipalAmount",
          headerName: "Taksitteki Anapara Tutarı",
          sortable: false,
          flex: 1.5,
          minWidth: 200,
          align: "right",
          headerAlign: "center",
          valueGetter: (params) => {
            return getNumberFormat(params.value);
          },
        },
        {
          field: "installmentInterest",
          headerName: "Faiz",
          sortable: false,
          align: "right",
          flex: 0.8,
          minWidth: 110,
          headerAlign: "center",
          valueGetter: (params) => {
            return getNumberFormat(params.value);
          },
        },
        {
          field: "bsmv",
          headerName: "BSMV",
          sortable: false,
          align: "right",
          flex: 0.8,
          minWidth: 110,
          headerAlign: "center",
          valueGetter: (params) => {
            return getNumberFormat(params.value);
          },
        },
        {
          field: "kkdf",
          headerName: "KKDF",
          sortable: false,
          align: "right",
          flex: 0.8,
          minWidth: 110,
          headerAlign: "center",
          valueGetter: (params) => {
            return getNumberFormat(params.value);
          },
        },
        {
          field: "principalAmount",
          headerName: "Kalan Anapara Tutarı",
          sortable: false,
          flex: 1.5,
          minWidth: 180,
          align: "right",
          headerAlign: "center",
          cellClassName: "wrapping",
          valueGetter: (params) => {
            return getNumberFormat(params.value);
          },
        },
      ]
}